import React, { useEffect, useRef, useState } from 'react';
import { MessageCircle, Star, Volume2, VolumeX } from 'lucide-react';

export function HeroSectionNew() {
  const heroSectionRef = useRef(null);
  const benCardRef = useRef(null);
  const videoRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [hasInteracted, setHasInteracted] = useState(false);

  const triggerElevenLabsWidget = () => {
    if (typeof window.openBenChat === 'function') {
      window.openBenChat('hero');
    }
  };

  // Handle video unmute (browsers block autoplay with sound)
  const handleUnmute = (e) => {
    e.stopPropagation();
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(videoRef.current.muted);
      if (!hasInteracted) {
        setHasInteracted(true);
        // Restart video from beginning when unmuting for first time
        videoRef.current.currentTime = 0;
        videoRef.current.play();
      }
    }
  };

  // Detect mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);


  // Simplified card styling - clean and professional
  const cardStyle = {
    boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease'
  };


  return (
    <section
      id="accueil"
      className="hero-section-new"
      ref={heroSectionRef}
    >
      {/* Blueprint Grid Overlay */}
      <div className="hero-grid-overlay"></div>
      {/* Blob removed for clean background */}
      <div className="hero-container">
        <div className="hero-left">
          {/* Left Card */}
          <div className="hero-card-figma" style={cardStyle}>
            <div className="hero-logo-figma">
              <img src="/logo/logo blanc.png" alt="CDGP" />
            </div>

            <div className="hero-bg-figma">
              <img src="/assets/team/ben-bg.png" alt="Ben - Expert Capillaire" />
            </div>

            <div className="hero-overlay-figma">
              <div className="hero-text-figma">
                <h1 className="hero-title-figma">
                  Retrouvez Vos Cheveux,<br />
                  <span className="hero-title-gold-figma">Retrouvez Votre Confiance</span>
                </h1>

                <p className="hero-description-figma">
                  Leader parisien de la greffe capillaire avec les techniques <strong>SAPHORÏ®</strong>, <strong>CHOÏ</strong> et <strong>SAPHIR</strong>
                </p>

                <button
                  className="hero-cta-figma"
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  <svg className="cta-icon-figma" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 11l3 3L22 4"></path>
                    <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"></path>
                  </svg>
                  DIAGNOSTIC CAPILLAIRE GRATUIT
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="hero-center">
          {/* Center Card (Ben) */}
          <div className="ben-card" ref={benCardRef} style={cardStyle}>
            <div className="ben-header">
              <div className="ben-avatar-container">
                <video
                  src="/ben-motion.mp4"
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="ben-avatar-video"
                />
                <div className="ben-status-indicator"></div>
              </div>
              <div className="ben-info">
                <div className="ben-name-container">
                  <h3 className="ben-name">Ben</h3>
                  <span className="expert-badge">Expert Capillaire</span>
                </div>
                <p className="ben-subtitle">Assistant Personnel Spécialisé</p>
                <div className="ben-stats-row">
                  <span className="ben-online">
                    <span className="online-dot"></span>
                    En ligne
                  </span>
                </div>
              </div>
            </div>

            <div className="ben-chat-body ben-video-container">
              {/* Ben intro video - autoplay muted (browser policy), click sound icon to unmute */}
              <video
                ref={videoRef}
                autoPlay
                muted
                playsInline
                className="ben-intro-video"
                src="/ben-intro-hero.mp4"
                onClick={triggerElevenLabsWidget}
              />
              {/* Sound toggle button */}
              <button
                className="ben-sound-toggle"
                onClick={handleUnmute}
                aria-label={isMuted ? "Activer le son" : "Couper le son"}
              >
                {isMuted ? <VolumeX size={20} /> : <Volume2 size={20} />}
                {isMuted && !hasInteracted && <span className="sound-hint">Cliquez pour le son</span>}
              </button>
              {/* CTA Button to trigger Eleven Labs widget */}
              <button
                className="ben-cta-talk"
                onClick={triggerElevenLabsWidget}
              >
                <MessageCircle size={20} />
                <span>Parler à Ben</span>
              </button>
            </div>
          </div>
        </div>

        <div className="hero-right">
          {/* Right Card */}
          <div className="video-testimonial-card" style={cardStyle}>
            <div className="testimonial-video-container">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="testimonial-video"
                src="https://cdgp.ricopoulos.com/hero-transformation-optimized.mp4"
              >
                Votre navigateur ne supporte pas la lecture vidéo.
              </video>

              <div className="testimonial-overlay-label">
                <span>Témoignages Patients</span>
                <div className="stars-small">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="star-icon-small" fill="#B89972" />
                  ))}
                </div>
                <span className="rating-small">4.9/5</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSectionNew;
